import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "./styles.css";
import { WalletGate, WalletProvider } from "./wallet";
import { ShieldedKeysProvider } from "./shielded/keys-context";
import { ShieldedBalanceProvider } from "./shielded/balance-context";
import { DeviceProvider } from "./lib/device-context";
import { ErrorBoundary } from "./components/ErrorBoundary";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

ReactDOM.createRoot(document.getElementById("app")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <DeviceProvider>
          <WalletProvider>
            <WalletGate>
              <ShieldedKeysProvider>
                <ShieldedBalanceProvider>
                  <App />
                </ShieldedBalanceProvider>
              </ShieldedKeysProvider>
            </WalletGate>
          </WalletProvider>
        </DeviceProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
